import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { getAirlineAddressByAirlineList, getIATAAgentAddressByIATAAgentList } from '../../../../../Redux/action/MasterAction';
import InputTextNumberOnlyJSX from './InputTextNumberOnlyJSX';
import InputTextJSX from './InputTextJSX';


const AddAirExpHAWBStockOffcanvas = ({
    show,
    handleClose,
    token,
    user_id,
    refresh
}) => {

    const [disableSubmit, setDisableSubmit] = useState(false);
 


    const initialValues = {
        prefix: "HAB",
        prefix_seperator: "",
        hawb_sequence: "",
        suffix_seperator: "",
        suffix: "",
        stock_date: "",
        no_of_hawb: 0
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/export/hawbstock/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            refresh();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add HAWB Stock</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit} >
                        <div className="row">
                            <InputTextJSX
                                labelText={"HAB Prefix"}
                                nameValue={"prefix"}
                                value={formik.values.prefix}
                                onChange={formik.handleChange}
                                splithalf={true}
                                maxLength={3}
                            />


                            <div className="col-md-3 mt-2">
                                <label htmlFor="prefix_seperator" className='form-label mb-0'>
                                    Seperator
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    // placeholder='First Four Digits'
                                    id="prefix_seperator"
                                    name='prefix_seperator'
                                    value={formik.values.prefix_seperator}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^/-]/g, ''); // Allow only "-" and "/"
                                        event.target.value = value;
                                    }}
                                    maxLength={1}
                                />

                            </div>
                            <InputTextNumberOnlyJSX
                                labelText={"HAB Sequence"}
                                nameValue={"hawb_sequence"}
                                value={formik.values.hawb_sequence}
                                onChange={formik.handleChange}
                                splithalf={true}
                                maxLength={12}
                            />
                            <div className="col-md-3 mt-2">
                                <label htmlFor="suffix_seperator" className='form-label mb-0'>
                                    Seperator
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    // placeholder='First Four Digits'
                                    id="suffix_seperator"
                                    name='suffix_seperator'
                                    value={formik.values.suffix_seperator}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    onInput={(event) => {
                                        let value = event.target.value;
                                        value = value.replace(/[^/-]/g, ''); // Allow only "-" and "/"
                                        event.target.value = value;
                                    }}
                                    maxLength={1}
                                />

                            </div>
                            <InputTextNumberOnlyJSX
                                labelText={"Suffix"}
                                nameValue={"suffix"}
                                value={formik.values.suffix}
                                onChange={formik.handleChange}
                                splithalf={true}
                                maxLength={4}
                            />
                            <div className="col-md-3 mt-2">
                                <label htmlFor="stock_date" className='form-label mb-0'>
                                    Stock Date
                                </label>
                                <input
                                    type="date"
                                    className="form-control form-control-sm"
                                    id="stock_date"
                                    name='stock_date'
                                    value={formik.values.stock_date}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </div>
                            <InputTextNumberOnlyJSX
                                labelText={"No.(Qty) of HAB"}
                                nameValue={"no_of_hawb"}
                                value={formik.values.no_of_hawb}
                                onChange={formik.handleChange}
                                splithalf={true}
                                maxLength={2}
                            />
                        </div>
                        <div className="row d-flex justify-content-end">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddAirExpHAWBStockOffcanvas